








import { Vue, Component, Prop } from 'vue-property-decorator'
import MarkdownViewerCrdt from 'components/MarkdownViewerCrdt.vue'
import { SlideParamsValuesSet } from 'src/assets/AttendeeItemData'

@Component({
  components: {
    MarkdownViewerCrdt
  }
})
export default class ItemTopicViewerSlide extends Vue {

  @Prop()
  readonly slide!: Json

  @Prop({ type: Object, default: () => { return {} } })
  readonly params!: SlideParamsValuesSet

  get text () {
    return this.slide?.text?.getText()
  }
}
